<template>
		<div class="o-layout o-layout--spacing-large">
			<section class="o-layout__item u-align-center">
				<h1 class="c-type-alpha u-bold u-type-pink">Page not found</h1>
				<p>Sorry, this page doesn't exist.</p>
			</section>
		</div>
</template>

<script>
export default {
	name: 'pageNotFound'
}
</script>



// WEBPACK FOOTER //
// pageNotFound.vue?6edf4f0e